import { TableCell, TableSortLabel } from "@mui/material";

interface SortableTableCellProps {
  label: string;
  sortKey: string;
  active: boolean;
  direction: "asc" | "desc";
  onClick: (key: string) => void;
  align?: "left" | "center" | "right";
}

const SortableTableCell: React.FC<SortableTableCellProps> = ({
  label,
  sortKey,
  active,
  direction,
  onClick,
  align = "left",
}) => {
  return (
    <TableCell align={align} sx={{ cursor: "pointer", backgroundColor: "#FAFAFA", fontWeight: 600 }}>
      <TableSortLabel
        active={active}
        direction={active ? direction : "asc"}
        onClick={() => onClick(sortKey)}
      >
        {label}
      </TableSortLabel>
    </TableCell>
  );
};

export default SortableTableCell;
